webpackJsonp([54639839271931],{

/***/ 2080:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UsageReport","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"orderItems","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"OrderItem","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"totals","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"UsageReportTotals","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-usage-report-e116e5c88ad967ff2fb0.js